// extracted by mini-css-extract-plugin
module.exports = {"orderTabs":"AiArtworks_orderTabs__RMmy9","specialActiveColor":"AiArtworks_specialActiveColor__h4svf"};